<template>
  <el-form-item :label="form.name" :prop="form.model"
               :class="[form.options.required?'label-blue':'']"
                :rules="form.rules"
                :required="form.options.required"
                v-show="!form.options.hidden"
                style="padding-left:10px;line-height:36px;"
  >
  <div v-if="unit.length>1">
      <el-row  style="width:226px">
        <el-col :span="9">
          <el-input-number v-model="value[form.modelLabel[0]]"
            @focus="focus($event)"
            @change="numChange1"
            :placeholder="form.options.placeholder"
            :disabled="inputDisable"    
             style="width:100%"    
            :min="0"
             :controls='false' 
            :max="9999999999"
            :step="0.01"
            :precision="2">
          </el-input-number>
        </el-col>
        <el-col :span="3" class="text_align_color" >{{unit[0]}}</el-col>
        <el-col :span="9">
          <el-input-number v-model="value[form.modelLabel[1]]"
            @focus="focus($event)"
            @change="numChange2"
            :placeholder="form.options.placeholder"
            :disabled="inputDisable"       
            style="width:100%"  
            :controls='false' 
            :min="0"
            :max="9999999999"
            :step="0.01"
            :precision="2">
                </el-input-number>
        </el-col>
        <el-col :span="3" class="text_align_color">{{unit[1]}}</el-col>
      </el-row>
    </div>
    <div v-else>
      <el-input-number v-model="value[form.model]"
              @focus="focus($event)"
              @change="numChange3"
              :placeholder="form.options.placeholder"
              :disabled="inputDisable"
              style="width:226px;text-align: right;"
              controls-position="right"
              :min="0"
              :max="9999999999"
              :step="0.01"
              :precision="2"
      >
      </el-input-number>
    </div>
  </el-form-item>
</template>
<style>
.text_align_color{
  text-align: center;
  background-color:#F5F7FA;
  border:1px solid #e9e9eb;
  border-radius:4px;
  border-left:0;
  height:36px;
}
</style>

<script>
//Junzzz：warning！！！！！！
//只针对维修记录双单位填写！！！！！！！！！！！！！！！！！！
export default {
  name: 'MeasureNumber',
  data () {
    return {
      key: '',
      unit:[],
      formData: {},
      mainValue: '',
    }
  },
  props: {
    form: {
      type: Object,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: () => {
        return {
          name: '',
          prop: '',
          icon: '',
          className: '',
          options: {
            width: "",
            required: false,
            defaultValue: 0,
            min: 0,
            max: 99999999,
            step: 1,
            precision:0,
            disabled: false,
            controlsPosition: "",
            customClass: "",
            labelWidth: 100,
            isLabelWidth: false,
            hidden: false,
            dataBind: true,
            remoteFunc: () => {},
            changeFunc: () => {}
          },
          unitData:"",
          key: '',
          model: 'value',
          modelLabel:[],
          rules: [{}]
        }
      }
    },
    value: Object,
    forms: {
      type: Object,
      default: () => { return {} }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
   model: {
    prop: 'value',
    event: 'input'
  },
  watch: {
    value: {
      immediate: true,
      handler: function (val, oldVal) {
        this.mainValue = val
      }
    },
    "form.unitData":function (newVal){
      this.setUnitData();
    }
  },
  methods: {
    focus(event) {
      event.currentTarget.select();
    },
    numChange1(val){
      let that = this
      if(!val){that.value[that.form.modelLabel[0]]=0;}
    },
    numChange2(val){
      let that = this
      if(!val){that.value[that.form.modelLabel[1]]=0;}
    },
    numChange3(val){
      let that = this
      if(!val){that.value[that.form.model]=0;}
    },
    onInput () {
      let that = this
      that.$emit('input', that.value, that.form.model)
      if (typeof that.form.options.changeFunc === 'function') { // 判断是否存在数据改变事件
        that.form.options.changeFunc(that.value[that.form.model], that, that.forms)
      }
    },
    setValue (val) {
      this.mainValue = val
    },
    setUnitData(){
      if(this.form.unitData&&(this.form.unitData.indexOf("/")>=0)){
        this.unit=this.form.unitData.split("/");
      }else{
        this.unit=this.form.unitData?[this.form.unitData]:"";
      }
    }
  },
  created () {
    let that = this
    that.key = that.form.key
    if (that.form.hasOwnProperty('options')) {
      that.value[that.form.model] = that.value[that.form.model] || this.form['options']['defaultValue'] || ''
    }
  },
  mounted () {
    let that = this
    that.$emit('init', that.key, that);
    that.setUnitData();
  },
  computed: {
    inputDisable () {
      return this.disabled || this.form.options.disabled
    }
  }
}
</script>

<style scoped>
  .el-input-number{
    width:229.49px;
  }
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/DynamicPages/Customize/MeasureNumber.vue"
}
</vue-filename-injector>
